import React, { FC } from 'react';
import { Typography } from '@mui/material';

const RING_RED = '#D32F2F';

/**
 * The question number shown to the left of a question.
 *
 * When `highlight` is set the number is drawn inside a red-white-red target so
 * the student can see at a glance that this one is coming back around after an
 * earlier wrong answer. The rings are box-shadows rather than nested elements,
 * so the badge takes up no more layout space than the plain number it replaces.
 */
export const QuestionNumber: FC<{ number: number; highlight?: boolean }> = ({
  number,
  highlight,
}) => {
  if (!highlight) {
    return (
      <Typography
        variant='h6'
        sx={{ fontWeight: 600, fontSize: '15px' }}
        style={{ margin: '2px 4px' }}>
        {number})
      </Typography>
    );
  }

  return (
    <span
      title='You answered this question incorrectly before'
      aria-label={`Question ${number}, previously answered incorrectly`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '0 0 auto',
        boxSizing: 'border-box',
        width: '26px',
        height: '26px',
        margin: '4px 10px 4px 6px',
        borderRadius: '50%',
        background: '#fff',
        border: `2px solid ${RING_RED}`,
        boxShadow: `0 0 0 2px #fff, 0 0 0 4px ${RING_RED}`,
        color: RING_RED,
        fontWeight: 700,
        fontSize: '13px',
        lineHeight: 1,
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      }}>
      {number}
    </span>
  );
};

export default QuestionNumber;
